export const common = {
  // Navigation
  home: 'الرئيسية',
  about: 'من نحن',
  services: 'خدماتنا',
  projects: 'مشاريعنا',
  contact: 'اتصل بنا',
  getQuote: 'احصل على عرض سعر',
  
  // Hero Section
  heroTitle: 'حقق مشروع التجديد الخاص بك في بروكسل',
  heroSubtitle: 'شركة بلجيكية موثوقة وشفافة وذات خبرة في أعمال التجديد والبناء',
  heroValueLine: 'عرض سعر مجاني • رد خلال 24 ساعة • متابعة شخصية',
  heroCTA: 'اطلب عرض سعر مجاني',
  
  // Trust Highlights
  trustTitle: 'لماذا تختار Ktran؟',
  trustExperience: 'أكثر من 15 عامًا من الخبرة الميدانية',
  trustLocal: 'شركة بلجيكية مقرها في بروكسل',
  trustTransparent: 'عروض أسعار واضحة ومتابعة دقيقة للأعمال',
  
  // Services
  servicesTitle: 'خدماتنا',
  servicesSubtitle: 'حلول شاملة لجميع احتياجات التجديد والبناء الخاصة بك',
  
  masonryTitle: 'البناء',
  masonryDesc: 'أعمال بناء صلبة ودائمة لتأمين وتثمين عقارك',
  
  bathroomTitle: 'الحمام والمطبخ',
  bathroomDesc: 'مساحات عصرية وعملية وجمالية، مصممة لراحتك اليومية',
  
  paintingTitle: 'الدهان والتشطيبات',
  paintingDesc: 'تشطيبات متقنة تبرز مساحاتك وتضمن نتيجة مثالية مع الوقت',
  
  partitionTitle: 'الجدران والعزل',
  partitionDesc: 'عزل فعال لتحسين راحتك الحرارية وتقليل نفقاتك الطاقية',
  
  carpentryTitle: 'النجارة',
  carpentryDesc: 'تركيب وتجديد الأبواب والنوافذ والتجهيزات المخصصة بحرفية عالية',
  
  electricalTitle: 'الكهرباء',
  electricalDesc: 'تركيبات كهربائية متوافقة مع المعايير البلجيكية لسلامتك وراحة بالك',
  
  // Process Steps
  processTitle: 'كيف نعمل',
  processSubtitle: 'عملية بسيطة وشفافة لضمان نجاح مشروعك',
  
  step1Title: 'تحليل مشروعك واحتياجاتك',
  step1Desc: 'نستمع إلى احتياجاتك ونقوم بزيارة الموقع لفهم مشروعك بشكل كامل',
  
  step2Title: 'دراسة تفصيلية وعرض سعر شفاف',
  step2Desc: 'نقدم لك عرض سعر مفصل وواضح بدون رسوم خفية',
  
  step3Title: 'تنفيذ الأعمال مع متابعة شخصية',
  step3Desc: 'نقوم بتنفيذ الأعمال باحترافية مع متابعة منتظمة وتواصل مستمر',
  
  // Projects
  projectsTitle: 'مشاريعنا المنجزة',
  projectsSubtitle: 'اكتشف بعض مشاريعنا المنجزة في بروكسل ومحيطها',
  projectNote: 'مشروع منجز بعناية، مع احترام المواعيد والميزانية',
  viewAllProjects: 'عرض جميع المشاريع',
  
  // Value Section
  valueTitle: 'التزامنا تجاهك',
  valueSubtitle: 'قيم توجه كل أعمالنا',
  
  qualityTitle: 'جودة العمل',
  qualityDesc: 'نستخدم مواد عالية الجودة ونطبق أفضل التقنيات لضمان نتائج دائمة وجمالية',
  
  timeTitle: 'احترام المواعيد',
  timeDesc: 'كل مشروع مخطط بدقة. نلتزم باحترام المواعيد المتفق عليها لراحة بالك',
  
  cleanTitle: 'موقع عمل نظيف',
  cleanDesc: 'نحافظ على موقع عمل منظم ونظيف طوال فترة الأعمال، مع تنظيف كامل في نهاية كل يوم',
  
  communicationTitle: 'تواصل شفاف',
  communicationDesc: 'نبقيك على اطلاع في كل مرحلة من المشروع. نبقى متاحين للإجابة على أسئلتك والتعديل حسب احتياجاتك',
  
  // Final CTA
  finalCTATitle: 'هل أنت مستعد لتحقيق مشروعك؟',
  finalCTAText: 'اتصل بنا اليوم للحصول على عرض سعر مجاني ومخصص. نرافقك من الفكرة الأولى حتى التسليم النهائي',
  finalCTAButton: 'اطلب عرض سعر مجاني',
  
  // Footer
  footerAbout: 'خبير في التجديد في بروكسل. نحول مساحاتك بجودة واحترافية',
  footerDescription: 'خبير في التجديد في بروكسل. نحول مساحاتك بجودة واحترافية.',
  footerQuickLinks: 'روابط سريعة',
  footerLegal: 'معلومات قانونية',
  footerContact: 'اتصل بنا',
  footerRights: 'جميع الحقوق محفوظة',
  
  // Legal Links - إضافة الترجمات المفقودة
  legalMentions: 'الإشعار القانوني',
  privacyPolicy: 'سياسة الخصوصية',
  cookiePolicy: 'سياسة ملفات تعريف الارتباط',
  termsOfUse: 'شروط الاستخدام',
  dataProtection: 'حماية البيانات',
  
  footerVAT: 'رقم الضريبة',
  poweredBy: 'مدعوم من BeneluxWeb',
  
  // Common Actions
  learnMore: 'اعرف المزيد',
  contactUs: 'اتصل بنا',
  callUs: 'اتصل بنا',
  emailUs: 'راسلنا',
  
  // Trust Signals
  registeredCompany: 'شركة مسجلة في بلجيكا',
  belgianStandards: 'احترام المعايير البلجيكية',
  qualityCommitment: 'التزام بالجودة ورضا العملاء',
  
  registeredCompanyDesc: 'شركة مسجلة قانونياً ومؤمنة لضمان سلامتك',
  belgianStandardsDesc: 'جميع أعمالنا تحترم بدقة اللوائح المعمول بها',
  qualityCommitmentDesc: 'رضاك هو أولويتنا، من عرض السعر حتى التسليم النهائي',
  
  // Stats
  projectsCompleted: 'مشروع منجز',
  yearsExperience: 'سنة من الخبرة',
  satisfiedClients: 'عملاء راضون',
  projectsDelivered: 'مشاريع مسلمة',
  
  // Time
  freeQuote: 'عرض سعر مجاني',
  response24h: 'رد خلال 24 ساعة',
  personalizedFollowup: 'متابعة شخصية'
};